import React, { Component } from 'react';
import './bootstrap-grid.min.css'
import './bootstrap.min.css'
import FeedbackMain from "./modules/feedback/view/FeedbackMain";
import Route from "react-router/es/Route";
import Home from "./modules/home/view/Home";
import { Link, Redirect } from "react-router-dom";
import './App.css';
import Imprint from "./modules/imprint/view/Imprint";
import { connect } from "react-redux";
import AppActions from "./AppActions";
import 'flag-icon-css/css/flag-icon.css';
import LanguageChooser from "./components/LanguageChooser";
import Contact from './modules/contact/view/Contact';
import Privacy from './modules/privacy/view/Privacy';
import Homebutton from './components/Homebutton';
import 'ionicons/dist/css/ionicons.min.css';
import TransitionGroup from "react-transition-group/TransitionGroup";
import {CSSTransition} from "react-transition-group";

const mapStateToProps = (state) => {
    return {
        language: state.application.language,

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
      switchLanguage: (language) => dispatch(AppActions.switchLanguage(language)),
      loadLanguagePackage: (language) => dispatch(AppActions.loadLanguagePackage(language)),
        setToken:(token) => dispatch(AppActions.setToken(token))
    }
};

class App extends Component {
  constructor(props){
      super(props);
      console.log(props);
  }
  componentDidMount(){
      if(this.props.match.params.lang !== "start"){
          this.props.switchLanguage(this.props.match.params.lang);
          this.props.loadLanguagePackage(this.props.match.params.lang);
          this.props.setToken(this.props.match.params.token);
      }else{
          let language = navigator.languages && navigator.languages[0] || // Chrome / Firefox
              navigator.language ||   // All browsers
              navigator.userLanguage;
          this.props.switchLanguage(language.split("-")[0]);
          this.props.loadLanguagePackage(language.split("-")[0]);
          this.props.setToken(this.props.match.params.token);
      }
  }

  render() {
    return (
      <div className="container flex-column">
        <div className="header">
          <div className="float-left">
            <Homebutton search={this.props.location.search} token={this.props.match.params.token} lang={this.props.language.active}/>
          </div>
          <Header data={this.props}/>
        </div>
                  <Route exact path="/:lang/home/:token" render={(props) => {
                      return <Home locale={props.match.params.lang}
                                   token={props.match.params.token}
                                   path={props.match.params.path}
                             />
                  }}/>
                  <Route exact path="/:lang/feedback/:token" render={(props) => {
                      return <FeedbackMain locale={props.match.params.lang}
                                           token={props.match.params.token}
                                           path={props.match.params.path}
                             />
                  }}/>
                  <Route exact path="/:lang/imprint/:token" render={(props) => {
                      return <Imprint locale={props.match.params.lang}
                                      token={props.match.params.token}
                                      path={props.match.params.path}
                                      history={props.history}
                             />
                  }}/>
                  <Route exact path="/:lang/contact/:token" render={(props) => {
                      return <Contact locale={props.match.params.lang}
                                      token={props.match.params.token}
                                      path={props.match.params.path}
                                      history={props.history}
                             />
                  }}/>
                  <Route exact path="/:lang/privacy/:token" render={(props) => {
                      return <Privacy locale={props.match.params.lang}
                                      token={props.match.params.token}
                                      path={props.match.params.path}
                                      history={props.history}
                             />
                  }}/>
        <div className="align-flex-end">
          {
            this.props.language.map != null ?
            <Footer props={this.props} location={this.props.location} language={this.props.language}/>
            :
            null
          }

        </div>
      </div>
    );
  }
}

class Footer extends React.Component{
  render(){
    return(
        <div className="row footer-layout">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex flex-row">
              <ul className="mr-auto">
                <li><a className="ion-logo-linkedin ml-auto" target="blank" href="https://de.linkedin.com/pub/harald-ackerschott/55/774/764"> </a></li>
                <li><a className="ion-logo-xing ml-auto" target="blank" href="https://www.xing.com/profile/Harald_Ackerschott"> </a></li>
                <li>
                  <Link to={{
                      pathname:"/" + this.props.props.language.active + "/imprint/" + this.props.props.match.params.token,
                      search: this.props.location.search
                  }}>{ this.props.language.map.labels.footer.imprint }</Link>
                </li>
                <li>
                  <Link to={{
                      pathname:"/" + this.props.props.language.active + "/contact/" + this.props.props.match.params.token,
                      search: this.props.location.search
                  }}>{ this.props.language.map.labels.footer.contact }</Link>
                </li>
                <li>
                  <Link to={{
                      pathname:"/" + this.props.props.language.active + "/privacy/" + this.props.props.match.params.token,
                      search: this.props.location.search
                  }}>{ this.props.language.map.labels.footer.privacy }</Link>
                </li>
              </ul>
          </div>
        </div>
    )
  }
}

class Header extends React.Component {
  render(){
    return(
      <div className="header-layout float-right">
          <LanguageChooser data={this.props}/>
      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js